<template>
    <UiBreadcrumbs v-editable="blok" :blok="blok" class="apr-breadcrumbs" />
</template>

<script lang="ts" setup>
import type { IBreadcrumbsConfig } from '@nuxt-monorepo/ui/types';

defineProps<{
    blok: IBreadcrumbsConfig;
}>();
</script>

<style lang="postcss" scoped>
:deep(.container) {
    @apply px-4 xl:px-0;
}
.apr-breadcrumbs {
    @apply text-text-primary-asphalt text-sm py-4 xl:py-8;

    :deep(.parent-link) {
        @apply text-text-secondary-grey;
    }
    :deep(.current-page) {
        @apply text-text-primary-asphalt;
    }
    :deep(.breadcrumbs-divider) {
        @apply px-3;
    }
    :deep(.home-link) {
        @apply hover:underline;
    }
}
</style>
